import {useDebugValue} from 'react';

import {noop} from '../../../utils/noop';

import {useEvents} from './useEvents';

const defaultSubmitEvents = {
    onSettingsChange: noop,
    onClick: noop
};

function useSubmitEvents(props) {
    const {
        submitEvents: propsSubmitEvents
    } = props;

    const {
        events: submitEvents
    } = useEvents(defaultSubmitEvents, propsSubmitEvents);

    const result = {
        submitEvents
    };

    useDebugValue(result);

    return result;
}

export {useSubmitEvents};
